import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=053c8830"
import script from "./Results.vue?vue&type=script&lang=ts"
export * from "./Results.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports